var VariationsWidget, base;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Collections == null) {
  VariationsWidget.Collections = {};
}

if ((base = VariationsWidget.Collections).Option == null) {
  base.Option = {};
}

if (VariationsWidget.Models == null) {
  VariationsWidget.Models = {};
}

VariationsWidget.Models.Option = require('./option');

VariationsWidget.Collections.Option = Backbone.Collection.extend({
  model: VariationsWidget.Models.Option,
  chosen: function(value) {
    return this.find(function(trait) {
      return trait.get('traitValue') === value;
    });
  },
  selected: function() {
    return this.find(function(trait) {
      return trait.get('selected');
    });
  },
  setSelected: function(id) {
    this.selected().set('selected', false);
    return this.get(id).set('selected', true);
  }
});

VariationsWidget.Collections.Option.create = function(traits) {
  var data, i, len, option, results, trait;
  results = [];
  for (i = 0, len = traits.length; i < len; i++) {
    trait = traits[i];
    data = (function() {
      var j, len1, ref, results1;
      ref = trait.data;
      results1 = [];
      for (j = 0, len1 = ref.length; j < len1; j++) {
        option = ref[j];
        results1.push({
          traitValue: option.value,
          disabled: false,
          forceDisplay: false,
          traitIndex: option.traitIndex,
          traitName: option.name,
          id: option.optionIndex,
          isSoldOut: option.isSoldOut,
          isUnavailable: option.isUnavailable,
          optionPrice: false,
          selected: option.optionIndex === 0
        });
      }
      return results1;
    })();
    results.push(new VariationsWidget.Collections.Option(data));
  }
  return results;
};

module.exports = VariationsWidget.Collections.Option;

//# sourceMappingURL=data:application/json;base64,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
